gsap.registerPlugin(ScrollTrigger);

// Select all elements with the class `.imageone`
gsap.utils.toArray(".imageone").forEach((image) => {
  gsap.to(image, {
    rotation: -4,
    y: -12,
    transformOrigin: "bottom left",
    duration: 1.5,
    ease: "power2.inOut",
    scrollTrigger: {
      trigger: image,
      start: "top 80%",
      once: true,
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const variantRadios = document.querySelectorAll(".variant-radio");
  const amazonBtns = document.querySelectorAll(".amazon-btn");
  const walmartBtns = document.querySelectorAll(".walmart-btn");

  function updateButtons(variant) {
    const amazonUrl = variant.dataset.amazonUrl;
    const walmartUrl = variant.dataset.walmartUrl;

    amazonBtns.forEach((btn) => {
      if (amazonUrl && amazonUrl !== "null" && amazonUrl !== "") {
        btn.href = amazonUrl;
        btn.style.display = "inline-block";
      } else {
        btn.style.display = "none";
      }
    });

    walmartBtns.forEach((btn) => {
      if (walmartUrl && walmartUrl !== "null" && walmartUrl !== "") {
        btn.href = walmartUrl;
        btn.style.display = "inline-block";
      } else {
        btn.style.display = "none";
      }
    });
  }

  variantRadios.forEach((radio) => {
    radio.addEventListener("change", function () {
      updateButtons(this);
    });
  });

  const defaultVariant = document.querySelector(".variant-radio:checked");
  if (defaultVariant) {
    updateButtons(defaultVariant);
  }
});
